<template>

    <div class="last__screen noselect">

        <h1 class="last__title">{{ $t('stories_screen_7_already_over') }}</h1>

        <markdown class="last__text" :text="$t('stories_screen_7_text_1')" :color="'#5ea774'"></markdown>

        <markdown class="last__text" :text="$t('stories_screen_7_text_2')" :color="'#5ea774'"></markdown>

        <p class="last__text"></p>

        <button class="btn btn-green last__btn" @click.self="close">Revenir aux statistiques</button>

        <div class="last__footer__container">

            <img src="/img/icons/lockSimple@2x.png" class="last__footer__img">

            <p class="last__footer__text">{{ $t('stories_screen_7_privacy') }}</p>

        </div>

    </div>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'last',

    components: { Markdown },

    props: {},

    methods: {

        close () {

            this.$emit('close')
        }

    }

}

</script>

<style scoped lang="scss">

    .last {
        &__screen {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            align-items:  baseline;
            justify-content: center;
            padding: 24px;
            background-color: $rifle;
            color: $sand;
            text-align: left;
        }

        &__title {
            font-size: 28px;
            font-weight: bolder;
        }

        &__text {
            font-size: 22px;
            font-weight: bolder;
            margin-top: 24px;
        }

        &__btn {
            background-color: $forest;
            margin: 12px auto 0;
            width: auto;
            padding: 0 16px;
        }

        &__footer {

            &__container {
                position: fixed;
                bottom: 24px;
                left: 24px;
                right: 24px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }

            &__img {
                width: 32px;
                object-fit: contain;
                margin: 0 auto;
            }

            &__text {
                font-size: 17px;
                margin-top: 8px;
                text-align: center;
                font-weight: bold;
            }
        }
    }

</style>
